import { registerAreaSeries } from "../../series/area/area";

import { SeriesTypeEnum } from "../../series/interface/type";

import { Factory } from "../../core/factory";

import { AreaChartSpecTransformer } from "./area-transformer";

import { BaseChart } from "../base";

export class AreaChart extends BaseChart {
    constructor() {
        super(...arguments), this.transformerConstructor = AreaChartSpecTransformer, this.type = "area", 
        this.seriesType = SeriesTypeEnum.area, this._canStack = !0;
    }
}

AreaChart.type = "area", AreaChart.seriesType = SeriesTypeEnum.area, AreaChart.transformerConstructor = AreaChartSpecTransformer;

export const registerAreaChart = () => {
    registerAreaSeries(), Factory.registerChart(AreaChart.type, AreaChart);
};
//# sourceMappingURL=area.js.map
